import {
  getBigNumbers,
  getBuildingDetails,
  getInfoWindow,
  getTransactionsList,
} from './realtyTransactions.infra';

import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';

import {
  addIWEventListener,
  createOpenInfoWindowT,
  generateMarkersOnMap,
} from './realtyTransactions.map';

import {
  buildCoordinatesReverse,
  removeEmptyFromResponse,
} from '../../../../shared/utils';

import {
  closeInfowindowTransactions,
  setInfowindowsTransactions,
  setLaunchingYearsTransactions,
  updateBuildingData,
  updateInputIntervals,
  updatePayloadChartsTransactions,
  updateRequestStatusT,
} from './realtyTransactions.actions';

import { AddAlert } from '../../../../component';

import {
  modalOpen,
  setDisplayCharts,
  setIsLoadingMap,
} from '../../redux/dashboardActions';

import { generalMarketsPayloadAdapter } from '../../../../shared/adapters';
import { updateChartsDataTransactions } from './realtyTransactions.actions';

let loadingStateController = {
  bigNumbers: false,
  sectors: false,
};

export const handleInputsIntervals = (e, v, tuple, typeNumber) => {
  return (dispatch) => {
    let name;
    if (!Number.isNaN(parseInt(e.value)) && parseInt(e.value) < 0) return;
    if (!e.value.match(/^(0|[1-9]\d*)+(,)?(\d{0,3})?$/) && e.value.length > 0)
      return;

    if (e.name.includes('min')) {
      tuple.min =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
      name = e.name.split('min')[0];
    } else {
      name = e.name.split('max')[0];
      tuple.max =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
    }

    const payload = {
      name,
      value: tuple,
    };
    dispatch(updateInputIntervals(payload));
  };
};

export const handlePriceInputs = (e, v, tuple, type) => {
  let name;
  let maskedValue = '';
  const replaceDots = e.value.replaceAll('.', '').split('R$');
  const valueAsFloat =
    replaceDots.length === 2
      ? parseInt(replaceDots[1])
      : parseInt(replaceDots[0]);
  if (!Number.isNaN(valueAsFloat)) {
    maskedValue = valueAsFloat.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0,
    });
  }
  if (e.name.includes('min')) {
    tuple.min = maskedValue;
    name = e.name.split('min')[0];
  } else {
    tuple.max = maskedValue;
    name = e.name.split('max')[0];
  }
  const payload = {
    name,
    value: tuple,
  };
  return (dispatch) => {
    dispatch(updateInputIntervals(payload));
  };
};

const fieldsDictionary = {
  timeframemin: 'Período Inicial',
  timeframemax: 'Período Final',
  transactionPriceRangemin: 'Preço de Transação Inicial',
  transactionPriceRangemax: 'Preço de Transação Final',
  m2PriceRangemin: 'Preço do m² Inicial',
  m2PriceRangemax: 'Preço do m² Final',
  privateAreaIntervalmin: 'Área Privativa Inicial',
  privateAreaIntervalmax: 'Área Privativa Final',
  realtyAgemin: 'Idade do Imóvel Inicial',
  realtyAgemax: 'Idade do Imóvel Final',
};

export const validateForm = (formData, validation, closeModalFunc, cityId) => {
  let flag = false;
  return (dispatch) => {
    if (!formData.realtyType.id) {
      dispatch(AddAlert('warning', 'Tipo de imóvel é um campo obrigatório'));
      flag = true;
    }
    if (!Object.values(validation)?.every((el) => el === false)) {
      const removedFalses = Object.entries(validation).filter(
        (el) => el[1] !== false
      );
      const errors = removedFalses.map((el) => fieldsDictionary[el[0]]);
      const invalidFields = errors.join(', ');
      const isPlural = errors.length > 1;
      dispatch(
        AddAlert(
          'warning',
          `Campo${isPlural ? 's' : ''} inválido${
            isPlural ? 's' : ''
          }: ${invalidFields}`
        )
      );
      flag = true;
    }
    if (!flag) {
      dispatch([payloadBuilderT(formData, null, cityId), closeModalFunc()]);
    }
  };
};

const bigNumbersResponseAdapter = (data) => {
  let bigNumbersDTO = {};

  const formattedResponse = removeEmptyFromResponse(data);

  const {
    total_existent_real_estates,
    total_transactions,
    existent_real_estates_median_age,
    transacted_real_estates_median_age,
  } = formattedResponse;

  if (total_existent_real_estates) {
    Object.assign(bigNumbersDTO, {
      existing_realties_count: total_existent_real_estates,
    });
  }
  if (total_transactions) {
    Object.assign(bigNumbersDTO, {
      transactioned_realties_count: total_transactions,
    });
  }
  if (existent_real_estates_median_age) {
    Object.assign(bigNumbersDTO, {
      existing_realties_median_age: existent_real_estates_median_age,
    });
  }
  if (transacted_real_estates_median_age) {
    Object.assign(bigNumbersDTO, {
      transactioned_median_age: transacted_real_estates_median_age,
    });
  }

  return bigNumbersDTO;
};

const generateCharts = (chartData) => {
  const DISPLAY_CHART_KEY = 'transactionsGeneral';
  return (dispatch) => {
    if (chartData) {
      dispatch([
        updateChartsDataTransactions(chartData),
        updateRequestStatusT({
          name: 'transactionedOverExistingRealties',
          value: 'LOADED',
        }),
        setDisplayCharts(DISPLAY_CHART_KEY),
      ]);
    } else {
      dispatch([
        updateRequestStatusT({
          name: 'transactionedOverExistingRealties',
          value: 'FAILED',
        }),
      ]);
    }
  };
};

export const generateBigNumbers = (payload, cityId) => {
  const formattedPayload = generalMarketsPayloadAdapter(
    payload,
    cityId,
    'transactions'
  );

  return (dispatch) => {
    dispatch(loading());
    dispatch(
      updateRequestStatusT({
        name: 'transactionedOverExistingRealties',
        value: 'LOADING',
      })
    );
    Promise.resolve(getBigNumbers(formattedPayload))
      .then((response) => {
        if (response?.data) {
          const { pins, big_numbers, transactions_over_existing_realties } =
            response.data;

          const bigNumbers = bigNumbersResponseAdapter(big_numbers);
          const chartData = {
            transactioned_over_existing_realties:
              transactions_over_existing_realties,
          };

          dispatch([
            generateMarkers(pins),
            setBigNumbers(bigNumbers),
            generateCharts({
              name: 'transactioned_over_existing_realties',
              value: chartData,
            }),
          ]);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        dispatch(loaded());
        loadingStateController.bigNumbers = true;
        if (loadingStateController.sectors) {
          dispatch(loaded());
          loadingStateController.sectors = false;
          loadingStateController.bigNumbers = false;
        }
      });
  };
};

export const generateMarkers = (pins) => {
  return (dispatch) => {
    dispatch(setIsLoadingMap(true));

    if (pins) {
      dispatch(generateMarkersOnMap(pins));
    }

    loadingStateController.sectors = true;

    if (loadingStateController.bigNumbers) {
      loadingStateController.sectors = false;
      loadingStateController.bigNumbers = false;
    }

    dispatch([setIsLoadingMap(false), loaded()]);
  };
};

let selectedInfoWindowCoords = [];
export const generateInfoWindow = (data, marker, coordinates) => {
  const payload = {
    ...data,
  };

  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getInfoWindow(coordinates))
      .then((response) => {
        dispatch(closeInfowindowTransactions());
        selectedInfoWindowCoords = data;
        const iw = createOpenInfoWindowT(response?.data, marker, data);
        dispatch([setInfowindowsTransactions([iw]), addIWEventListener()]);
      })
      .catch((error) => console.error(error))
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

export const generateBuildingDetails = (payload) => {
  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getBuildingDetails(selectedInfoWindowCoords))
      .then((res) => {
        dispatch([
          updateBuildingData(res?.data),
          modalOpen('open building transactions'),
        ]);
      })
      .catch((err) => console.error(err))
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

export const generateTransactionsList = () => {
  let launchingYearTransactions =
    JSON.parse(localStorage.getItem('LaunchingYearsTransactions')) || undefined;
  return (dispatch) => {
    if (launchingYearTransactions === undefined) {
      dispatch(loading());
      Promise.resolve(getTransactionsList())
        .then((res) => {
          launchingYearTransactions = res.data.years_with_transactions;
          localStorage.setItem(
            'LaunchingYearsTransactions',
            JSON.stringify(launchingYearTransactions)
          );

          dispatch(setLaunchingYearsTransactions(launchingYearTransactions));
        })
        .catch((err) => console.error(err))
        .finally((_) => dispatch(loaded()));
    } else {
      dispatch(setLaunchingYearsTransactions(launchingYearTransactions));
    }
  };
};

export const payloadBuilderT = (data, moreFilters, cityId) => {
  const location = buildCoordinatesReverse();

  let inputIntervals = {};

  Object.keys(data.inputIntervals).forEach((el) => {
    const val = data.inputIntervals[el];
    if (val.min !== '' && val.max !== '') {
      const validateValue = {
        min: val.min.toString(),
        max: val.max.toString(),
      };
      if (validateValue.min.includes(','))
        validateValue.min = validateValue.min.replace(',', '.');
      if (validateValue.max.includes(','))
        validateValue.max = validateValue.max.replace(',', '.');
      if (el !== 'timeframe') {
        inputIntervals = {
          ...inputIntervals,
          [el]: {
            min: Number(validateValue.min),
            max: Number(validateValue.max),
          },
        };
      } else {
        inputIntervals = {
          [el]: { min: validateValue.min, max: validateValue.max },
        };
      }
    }
  });

  data = {
    ...data,
    inputIntervals,
  };
  if (!location) {
    return (dispatch) => {
      dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
    };
  } else {
    const payload = moreFilters
      ? {
          location,
          ...data,
          moreFilters,
        }
      : {
          location,
          ...data,
        };
    return (dispatch) => {
      if (payload.inputIntervals.timeframe) {
        localStorage.setItem(
          'TimeFrame',
          JSON.stringify(payload.inputIntervals.timeframe)
        );
      }
      dispatch([
        generateBigNumbers(payload, cityId),
        updatePayloadChartsTransactions(payload),
      ]);
    };
  }
};
